import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap, throwError } from 'rxjs';
import { ApiService } from './api.service';
import { ListService } from './list.service';
import { PortalDataIndicatorModel } from '../models/portal-data-indicator.model';
import { catchError } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class PortalDataIndicatorService extends ListService {
  protected dataSubject = new BehaviorSubject<PortalDataIndicatorModel>({});
  public data$ = this.dataSubject.asObservable();

  constructor(public _apiService: ApiService) {
    super();
  }

  getList(): Observable<PortalDataIndicatorModel> {
    return this._apiService
      .get<PortalDataIndicatorModel>('portal-data-list-indicator')
      .pipe(
        tap(response => this.dataSubject.next(response)),
        catchError((error: HttpErrorResponse) => {
          if (error.status === 404) {
            this.dataSubject.next({});
          }
          return throwError(() => error);
        })
      );
  }

  refreshData() {
    this.getList().subscribe();
  }
}
